import { render, staticRenderFns } from "./pageElementContent.vue?vue&type=template&id=d84761b6&"
import script from "./pageElementContent.vue?vue&type=script&lang=js&"
export * from "./pageElementContent.vue?vue&type=script&lang=js&"
import style0 from "./pageElementContent.vue?vue&type=style&index=0&id=d84761b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports